import { SNS } from '../interfaces/common'

export interface TokenPriceWithChange {
  [tokenId: string]: {
    price: number
    priceChange: number
    volume24h?: number
  }
}

export interface Locale {
  id: string
  currency: {
    code: string
    symbol: string
    name: string
    usdExchangeRate: number
  }
  numberFormat?: string
  flagEmoji: string
}

export interface WebApp {
  title: string
  logo: string
  url: string
}

interface TradedTokens {
  chain: string
  tokens: {
    id: string
    volume_24h: number
  }[]
}

class CacheClient {
  private async request<T>(url: string) {
    const result = await fetch(url, { cache: 'no-cache' })

    if (result.ok) {
      return result.json() as Promise<T>
    } else {
      throw await result.text()
    }
  }

  getTokenPrices(): Promise<TokenPriceWithChange> {
    return this.request('https://plug-cache.s3.amazonaws.com/v2/token-prices.json')
  }

  getSns(): Promise<SNS[]> {
    return this.request('https://plug-cache.s3.amazonaws.com/v2/sns.json')
  }

  async getLocales(): Promise<Locale[]> {
    return this.request('https://plug-cache.s3.amazonaws.com/v2/locales.json')
  }

  getDappUrls(): Promise<WebApp[]> {
    return this.request('https://plug-cache.s3.amazonaws.com/webAppUrls.json')
  }

  getTopTradedTokens(): Promise<TradedTokens[]> {
    return this.request('https://plug-cache.s3.amazonaws.com/v2/top-traded-tokens.json')
  }
}

export default CacheClient
